import { Injectable, NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule, RouterStateSnapshot, Routes, TitleStrategy } from '@angular/router';

import { AuthGuardService } from './core/auth.guard';

const routes: Routes = [
  {
    path: '',
    canLoad: [AuthGuardService],
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
  },
];

@Injectable({ providedIn: 'root' })
export class TemplatePageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const moduleName = routerState?.root?.firstChild?.firstChild?.routeConfig?.title;
    const title = this.buildTitle(routerState);
    this.title.setTitle(
      `${title && title !== moduleName ? `${title} | ` : ''}nDziekanat${moduleName ? ` ${moduleName}` : ''}`,
    );
  }
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
  providers: [{ provide: TitleStrategy, useClass: TemplatePageTitleStrategy }],
})
export class AppRoutingModule {}
